export default __webpack_public_path__ + "static/media/icon-campaign.e8eb579f.svg";